// PS-02: sipariş önerisi lokasyon kırılımını kompakt bir metne çevirir.
// Net-toplam yeterli görünse bile hangi lokasyonun eksik olduğunu operatöre gösterir.
export function formatLokasyonEksik(oneri) {
  const kirilim = oneri && oneri.lokasyon_kirilim;
  if (!Array.isArray(kirilim) || kirilim.length === 0) return null;
  const birim = (oneri.birim || '').trim();
  const ek = birim ? ` ${birim}` : '';
  if (kirilim.length <= 2) {
    return kirilim.map((l) => `${l.lokasyon_ad}: −${l.acik}${ek}`).join(' · ');
  }
  return `${kirilim.length} lokasyonda eksik · toplam −${oneri.lokasyon_acik_toplam}${ek}`;
}
